
import { CartLinesUpdateEvent } from '@shopify/events';
/* [04]-STUDIOS Collection quick add, native Shopify cart event integration. */
if (!window.__collectionSystem04Loaded) {
  window.__collectionSystem04Loaded = true;
  const root = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const closePanels = except => {
    document.querySelectorAll('.pg04-v2 .pg-options').forEach(panel => {
      if (panel === except) return;
      panel.hidden = true;
      const openButton = document.querySelector('[aria-controls="' + CSS.escape(panel.id) + '"]');
      openButton?.setAttribute('aria-expanded','false');
    });
  };
  document.addEventListener('click', async event => {
    const opener = event.target.closest('.pg04-v2 [data-pg-open]');
    if (opener) {
      event.preventDefault();
      const panel = document.getElementById(opener.getAttribute('aria-controls'));
      if (!panel) return;
      const wasHidden = panel.hidden;
      closePanels();
      panel.hidden = !wasHidden;
      opener.setAttribute('aria-expanded',wasHidden?'true':'false');
      return;
    }
    const btn = event.target.closest('.pg04-v2 [data-pg-add]');
    if (!btn) {
      if (!event.target.closest('.pg04-v2 .pg-options')) closePanels();
      return;
    }
    event.preventDefault();
    if (btn.disabled) return;
    const id = Number(btn.dataset.pgAdd);
    if (!Number.isSafeInteger(id) || id <= 0) return;
    const card = btn.closest('.pg-item');
    const status = card?.querySelector('.pg-add-status');
    btn.disabled = true;
    if(status) status.textContent='';
    const deferred = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(new CartLinesUpdateEvent({
      action:'add',context:'product',
      lines:[{merchandiseId:String(id),quantity:1}],promise:deferred.promise
    }));
    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0,5);
      const response = await fetch(root()+'cart/add.js',{
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id,quantity:1}],sections,sections_url:location.pathname})
      });
      const result=await response.json();
      if(!response.ok || result.status) throw new Error(result.description || 'Could not add this item.');
      const cResponse=await fetch(root()+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!cResponse.ok) throw new Error('Cart refresh failed.');
      const cart=await cResponse.json();
      deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail:{items:cart.items,sections:result.sections,source:'product-form-component',
          itemCount:1,productId:btn.dataset.productId,didError:false}});
      if(status)status.textContent='Added to cart';
      closePanels();
    } catch(err) {
      deferred.reject(err);
      if(status) status.textContent=err.message||'Unable to add item.';
    } finally {
      btn.disabled=false;
    }
  });
  document.addEventListener('keydown', e=>{if(e.key==='Escape')closePanels();});
}
